import { getConfigSetup } from '@/utils/utils';
import BaseService from '../base.service'
class HistoryService extends BaseService {
    async getLastNBet(limit: number) {
        const configSetup = getConfigSetup(); 
        return await this.get(configSetup.apiUrl + `/api/retail/report/last-n-bet/${limit}`).then(({ data }) => data)
    }
}

export default new HistoryService()
